import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-track-number-popup',
  templateUrl: './track-number-popup.component.html',
  styleUrl: './track-number-popup.component.scss'
})
export class TrackNumberPopupComponent implements OnInit{
  trackNumber?: string

  private dialogRef: MatDialogRef<TrackNumberPopupComponent> = inject(MatDialogRef<TrackNumberPopupComponent>)
  private data: { trackNumber?: string } = inject(MAT_DIALOG_DATA)
  constructor(
  ) {
    this.trackNumber = this.data?.trackNumber
  }

  ngOnInit() {
  }

  copyToClipboard(): void {
    if (this.trackNumber) {
      navigator.clipboard.writeText(this.trackNumber).then(() => {
        alert('Track number copied to clipboard!');
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      });
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
